import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Plus, ShoppingCart } from 'lucide-react';
import { useCartStore } from '../store';
import toast from 'react-hot-toast';

export default function MarketPage() {
  const { addItem } = useCartStore();

  const { data: categories = [], isLoading: catsLoading } = useQuery({
    queryKey: ['categories-market'],
    queryFn: async () => {
      const { data } = await axios.get('http://localhost:5000/api/categories?pageSize=100');
      // Filtreleme: Sadece "Market" (Type = 1) kategorileri
      return data.filter((c: any) => c.type === 2).sort((a: any, b: any) => a.sortOrder - b.sortOrder);
    }
  });

  const { data: productsData, isLoading: prodsLoading } = useQuery({
    queryKey: ['products-market'],
    queryFn: async () => {
      const { data } = await axios.get('http://localhost:5000/api/products?pageSize=100');
      // Filtreleme: Sadece "Market" (Type = 1) ürünleri ve aktif olanlar
      return data.items.filter((p: any) => p.type === 2 && p.isActive);
    }
  });

  const products = productsData || [];

  const handleAddToCart = (product: any) => {
    addItem('market', {
      productId: product.id,
      name: product.name,
      price: product.price,
      imageUrl: product.imageUrl,
      quantity: 1,
    });
    toast.success(`${product.name} sepete eklendi!`);
  };

  if (catsLoading || prodsLoading) {
    return <div className="container py-12"><div className="skeleton h-96 w-full rounded-xl"></div></div>;
  }

  return (
    <div className="container py-8 animate-fade-in">
      <div className="flex items-center gap-4 mb-8">
        <h1 className="text-4xl font-bold">🛒 Market</h1>
        <p className="text-muted mt-2">İhtiyaçların dakikalar içinde kapında.</p>
      </div>

      {categories.length === 0 ? (
        <div className="card text-center py-16 text-muted border-dashed">
          <ShoppingCart size={48} className="mx-auto mb-4 opacity-50" />
          <h3 className="text-xl font-bold mb-2">Henüz market kategorisi yok</h3>
          <p>Admin panelinden yeni kategoriler ve ürünler eklendiğinde burada görünecektir.</p>
        </div>
      ) : (
        <div className="space-y-12">
          {categories.map((category: any) => {
            const categoryProducts = products.filter((p: any) => p.categoryId === category.id);
            
            if (categoryProducts.length === 0) return null;

            return (
              <section key={category.id} id={`category-${category.id}`}>
                <h2 className="text-2xl font-bold mb-6 pb-2 border-b border-border flex items-center justify-between">
                  {category.name}
                  <span className="badge badge-neutral text-sm">{categoryProducts.length} Ürün</span>
                </h2>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                  {categoryProducts.map((product: any) => (
                    <div key={product.id} className="card p-0 flex flex-col hover:border-primary/50 transition cursor-pointer group" style={{ overflow: 'hidden' }}>
                      <div style={{ position: 'relative', width: '100%', height: '160px', overflow: 'hidden', flexShrink: 0, backgroundColor: 'var(--surface-2, #f5f5f5)' }}>
                        {product.imageUrl ? (
                          <img
                            src={product.imageUrl}
                            alt={product.name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                          />
                        ) : (
                          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '3rem' }}>
                            🛒
                          </div>
                        )}
                        {product.stock <= 0 && (
                          <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
                            <span className="bg-error text-white font-bold px-3 py-1 rounded-full text-sm">Tükendi</span>
                          </div>
                        )}
                      </div>
                      
                      <div className="flex flex-col flex-1 p-4">
                        <div className="flex-1">
                          <h3 className="font-bold text-lg mb-1">{product.name}</h3>
                          {product.description && (
                            <p className="text-sm text-muted line-clamp-2 mb-3">{product.description}</p>
                          )}
                        </div>
                        
                        <div className="flex items-center justify-between mt-4 pt-4 border-t border-border">
                          <span className="font-bold text-primary text-xl">{product.price} ₺</span>
                          <button 
                            onClick={() => handleAddToCart(product)}
                            disabled={product.stock <= 0}
                            className="btn btn-sm btn-primary rounded-full w-10 h-10 p-0 flex items-center justify-center"
                            title="Sepete Ekle"
                          >
                            <Plus size={20} />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            );
          })}
        </div>
      )}
    </div>
  );
}
